import { Controller } from "@hotwired/stimulus"

const KEY = "outreach-theme"
const THEMES = [ "light", "dark" ]

// Light or Dark, chosen in the avatar menu: stored in localStorage as
// outreach-theme and applied as <html data-theme>. Anything else stored (an
// old "system", say) or nothing at all means light. The layout's inline
// <head> script applies it before first paint; other tabs follow through the
// storage event (01 › Dark mode).
export default class extends Controller {
  connect() {
    this.follow = this.follow.bind(this)
    window.addEventListener("storage", this.follow)
    this.apply(this.stored())
  }

  disconnect() {
    window.removeEventListener("storage", this.follow)
  }

  choose(event) {
    if (event.target.name !== KEY || !THEMES.includes(event.target.value)) return

    try { localStorage.setItem(KEY, event.target.value) } catch {}
    this.apply(event.target.value)
  }

  follow(event) {
    if (event.key === KEY) this.apply(this.stored())
  }

  stored() {
    try {
      const theme = localStorage.getItem(KEY)
      return THEMES.includes(theme) ? theme : "light"
    } catch {
      return "light"
    }
  }

  apply(theme) {
    document.documentElement.dataset.theme = theme
    this.element.querySelectorAll(`input[name="${KEY}"]`).forEach((radio) => {
      radio.checked = radio.value === theme
      radio.closest("[role=menuitemradio]")?.setAttribute("aria-checked", String(radio.checked))
    })
  }
}
